export const ARIA_LABEL = {
  toggleOn: 'Toggle on to accept the use of cookies',
  toggleOff: 'Toggle off to deny the use of cookies',
}
